import { Injectable, signal } from '@angular/core';
import { AbstractCategoryFormService } from '../../../common/category-details/abstract-category-form-service';
import {
  createLocationCategoryAsync,
  findLocationCategoryAsync,
  updateLocationCategoryAsync,
} from '../../../../backend/main';
import type { CategoryDetailsFormValues } from '../../../common/category-details/category-details-form';
import { CategoryDetailsForm } from '../../../common/category-details/category-details-form';

@Injectable()
export class LocationsCategoryFormService extends AbstractCategoryFormService<CategoryDetailsFormValues> {
  readonly i18nPrefix = signal('PAGES.LOCATION.CATEGORY');

  readonly findCategoryAsync = findLocationCategoryAsync;
  readonly createCategoryAsync = createLocationCategoryAsync;
  readonly updateCategoryAsync = updateLocationCategoryAsync;

  createForm(): CategoryDetailsForm {
    return new CategoryDetailsForm();
  }
}
